export default function findElementFrom(element, criteriaFn) {
  if (element === null) return null;

  return criteriaFn(element)
    ? element
    : findElementFrom(element.parentElement, criteriaFn);
}
